import React from 'react'

import {useEmailValidationErrorMessage} from '@/hooks/use-email-validation-error-message'
import useSignup from '@/hooks/use-signup'
import type {Args as UseSignupArgs} from '@/hooks/use-signup'
import {SimpleSignupForm} from '@helios/shared/components/simple-signup-form'

export interface Props {
    placeholder: string
    submitText: string
    formId: string
    errorText?: string
    withBorder?: boolean
    signupOptions?: UseSignupArgs
    stacked?: boolean
    ariaLabel?: string
    dataTestId?: string
}

const SimpleSignupFormContainer = ({signupOptions, formId, ...props}: Props) => {
    const signupProps = useSignup(
        signupOptions || {
            form: 'Front',
        },
        formId
    )
    const errorMessage = useEmailValidationErrorMessage(signupProps.error)

    return <SimpleSignupForm {...props} {...signupProps} errorText={errorMessage} />
}

export default SimpleSignupFormContainer
